import { render, staticRenderFns } from "./EnquiryCreate.vue?vue&type=template&id=40506a7e&"
import script from "./EnquiryCreate.vue?vue&type=script&lang=js&"
export * from "./EnquiryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCard,QCardSection,QList,QItem,QItemSection,QIcon,QSeparator,QCardActions,QToolbar,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QCard,QCardSection,QList,QItem,QItemSection,QIcon,QSeparator,QCardActions,QToolbar})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
